import { Navigate, Outlet } from "react-router-dom";
import IdleLogout from "./IdleLogout";

export default function ProtectedLayout() {
  const token = localStorage.getItem("token");

  // Not logged in → send to login
  if (!token) {
    return <Navigate to="/login" replace />;
  }

  return (
    <>
      <IdleLogout />
      <Outlet />
    </>
  );
}
